<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="20" style="text-align: left;display: flex;align-items: center;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item size="medium">
                            <template v-for="(item,index) in stepArr">
                                <el-badge 
                                    style="margin-right: 25px;" 
                                    :value="item.JobCount" 
                                    :max="1000" 
                                    :key="index" 
                                    :hidden="form.JobStep == item.JobStep || item.JobCount == 0 || item.JobStepName == '已完成'"
                                >
                                    <el-button 
                                        size="mini" 
                                        :class="{'selected':form.JobStep == item.JobStep}"  
                                        @click="handleSearchType(item.JobStep)"
                                    >
                                        {{item.JobStepName}}
                                    </el-button>
                                </el-badge>
                            </template>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4">
                    <el-form inline label-width="90px" label-position="left" style="text-align: right;">
                        <el-form-item>
                            <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            border
            style="width: 100%;margin-top: 20px;"
            height="640"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="工单ID">
                <el-table-column show-overflow-tooltip width="100">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.JobId" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobId || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单号">
                <el-table-column show-overflow-tooltip width="120">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.JobNo" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobNo || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column label="类别">
                <el-table-column show-overflow-tooltip width="100">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.IsProjectJob" placeholder="请选择" style="width: 100%;">
                            <el-option :value="0" label="全部"></el-option>
                            <el-option :value="1" label="项目"></el-option>
                            <el-option :value="2" label="标准"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsProjectJob?'项目':'标准'}}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
            <el-table-column label="工单名称">
                <el-table-column show-overflow-tooltip width="260">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.Title" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>
                            <i 
                                v-if="scope.row.IsUrgent" 
                                class="iconfont icon-jiaji" 
                                style="font-size: 48px;display: inline-block;vertical-align: top;color: #f75959;margin-right:5px;">
                            </i>{{(scope.row.Title || '--')}}
                        </span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="服务城市">
                <el-table-column show-overflow-tooltip width="150">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="region" placeholder="请选择" @click.native="isRegionShow"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.ProvinceName">{{scope.row.ProvinceName}} · {{scope.row.CityName}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单方">
                <el-table-column show-overflow-tooltip width="150">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.SenderUserName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SenderName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发单时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="上门开始时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.ExecStartDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                    <span>{{scope.row.ExecStartDate|| '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="上门结束时间">
                <el-table-column show-overflow-tooltip width="180">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.ExecEndDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                    <span>{{ scope.row.ExecEndDate || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="工单进度">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.JobStep" placeholder="请选择" style="width: 100%;">
                            <el-option :value="item.JobStep" :label="item.JobStepName" v-for="(item, index) in stepArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.JobStepText || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="对接人">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.AdminUserId" placeholder="请选择" style="width: 100%;">
                            <el-option :value="item.UserId" :label="item.RealName" v-for="(item, index) in djrArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.TakeOverUserName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="130" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="linkjobInfoFun(scope.row.JobId)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog 
            :visible.sync="areaShow" 
            title="服务城市" 
            width="34%" 
            ref="dialog"
            append-to-body
        >
            <el-form ref="area" label-width="60px" >
                <el-form-item label="地址：">
                    <el-select 
                        size="medium" 
                        value-key="aid"
                        v-model="regionForm.ProvinceId"
                        placeholder="省"
                        filterable
                        clearable
                        style="width: 48%;margin-right: 10px;"
                        @change="ProvinceIdFun"
                    >
                        <el-option 
                            v-for="(item, index) in ProvinceIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                    <el-select 
                        size="medium" 
                        value-key="aid" 
                        v-model="regionForm.CityId" 
                        placeholder="市" 
                        filterable 
                        clearable 
                        style="width: 48%;margin-right: 10px;" 
                    >
                        <el-option 
                            v-for="(item, index) in CityIdList" 
                            :value="item" 
                            :label="item.areaname" 
                            :key="index"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddressFun">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        getJobStepList,         //获取工单列表分类
        getJobStatusList,       //获取工单状态
        getTakeOverUserList,    //获取负责人
        getJobFreeList,         //获取自由工单列表
    } from "@/service/job";
    import {
        optionsArea,        //省市区
    } from "@/service/area";
    import { 
        // getStorageUserRoleId,
        getActionData
    } from '@/utils/store'
    export default {
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    JobStep: 0,             //工单状态
                    JobId: '',              //工单id
                    JobNo: '',              //工单编号
                    IsProjectJob:0,//项目类别
                    Title: '',              //标题
                    SenderUserName: '',     //发单方用户名称
                    CreateTime: [],         //时间
                    ExecStartDate:[],//上门开始时间
                    ExecEndDate:[], //上门结束时间
                    JobStatus: '',          //工单状态
                    AdminUserId: '',        //对接人id

                },
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
                // 地区
                areaShow: false,
                region: '', 
                regionForm: {
                    ProvinceId: '', //省
                    CityId: '', //市
                },
                ProvinceIdList: [],
                CityIdList: [],
                // select
                stepArr:  [ {
                            "JobStep": 0,
                            "ParentJobStep": 0,
                            "JobStepName": "全部",
                            "JobCount": 0
                        }, {
                        "JobStep": 3,
                        "ParentJobStep": 0,
                        "JobStepName": "待支付押金",
                        "JobCount": 0
                        }, {
                        "JobStep": 5,
                        "ParentJobStep": 0,
                        "JobStepName": "投标中",
                        "JobCount": 0
                        }, {
                        "JobStep": 6,
                        "ParentJobStep": 0,
                        "JobStepName": "投标已过期",
                        "JobCount": 0
                        }, {
                        "JobStep": 8,
                        "ParentJobStep": 0,
                        "JobStepName": "服务中",
                        "JobCount": 0
                        },  {
                        "JobStep": 9,
                        "ParentJobStep": 0,
                        "JobStepName": "工单变更",
                        "JobCount": 0
                        },   {
                        "JobStep": 10,
                        "ParentJobStep": 0,
                        "JobStepName": "报告待审核",
                        "JobCount": 0
                        },  {
                        "JobStep": 11,
                        "ParentJobStep": 0,
                        "JobStepName": "待同意付款",
                        "JobCount": 0
                        }, {
                        "JobStep": 13,
                        "ParentJobStep": 0,
                        "JobStepName": "已完成",
                        "JobCount": 0
                        }, {
                        "JobStep": 17,
                        "ParentJobStep": 0,
                        "JobStepName": "挂起",
                        "JobCount": 0
                        }],
                //分类状态
                statusArr:[],           //select 工单状态
                djrArr: [{"UserId":0,"RealName":'全部'},{"UserId":-1,"RealName":'无对接人'}],             //负责人
            };
        },
        // activated(){
        //     this.handleSearch()
        // },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            // this.GetJobStatusListFun();
            this.GetTakeOverUserListFun();
            this.handleSearch()
        },
        methods: {
            // 获取工单列表分类
            GetJobStepListFun(){
                getJobStepList({JobType:1,IsJobList:1,IsJobCount:1}).then(res=> {
                    this.stepArr = res.Data;

                    // console.log(" this.stepArr:"+JSON.stringify( this.stepArr));
                });
            },
            // 获取工单状态
            GetJobStatusListFun(){
                getJobStatusList().then(res=> {
                    this.statusArr = res.Data
                })
            },
            // 获取对接人
            GetTakeOverUserListFun(){
                getTakeOverUserList().then(res=> {
                    this.djrArr =[...this.djrArr,...res.Data];
                })
            },
            // 分类
            handleSearchType(type){
                this.form.JobStep = type 
                this.handleSearch()
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.regionForm = {
                    ProvinceId: '', //省
                    CityId: '', //市
                    XianId: '', //区
                }
                this.region = ''
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.searchData.pageNum = 1
                this.searchData.pageSize = val
                this.GetJobFreeListFun()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.searchData.pageNum = val
                this.GetJobFreeListFun()
            },
            //获取我的客户列表
            async GetJobFreeListFun(){
                if(this.searchData.JobId)
                {
                    if (!/^\d+$/.test(this.searchData.JobId)) {
                        return this.$message.error("工单Id请输入数字");
                    }
                }
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.JobId && delete data.JobId
                !data.JobNo && delete data.JobNo
                !data.Title && delete data.Title
                 data.ProvinceId = this.regionForm.ProvinceId.aid
                 data.CityId = this.regionForm.CityId.aid
                !data.ProvinceId && delete data.ProvinceId
                !data.CityId && delete data.CityId
                !data.SenderUserName && delete data.SenderUserName
                !data.AdminUserId && delete data.AdminUserId
                if (data.CreateTime && data.CreateTime.length) {
                    data.StartCreateTime = data.CreateTime[0] + ' 00:00:01'
                    data.EndCreateTime = data.CreateTime[1] + ' 23:59:59'
                }
                delete data.CreateTime

                if (data.ExecStartDate && data.ExecStartDate.length) {
                    data.ExecStartDateStart = data.ExecStartDate[0]  
                    data.ExecStartDateEnd = data.ExecStartDate[1] 
                }
                delete data.ExecStartDate

                if (data.ExecEndDate && data.ExecEndDate.length) {
                    data.ExecEndDateStart = data.ExecEndDate[0]  
                    data.ExecEndDateEnd = data.ExecEndDate[1] 
                }
                delete data.ExecEndDate


                !data.JobStatus && delete data.JobStatus
                let res = await getJobFreeList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.JobList
                this.total = res.Data.TotalCount
                this.GetJobStepListFun();
            },
            // 地区
            isRegionShow(){
                this.areaShow = true
                this.$nextTick(()=>{
                    this.getAreaDataByParentFun(0,1)
                })
            },
            // 点击省份
            ProvinceIdFun(){
                this.getAreaDataByParentFun(this.regionForm.ProvinceId.aid,2)
                this.regionForm.CityId = {aid : '',areaname: ''}
            },
            // 点击地址确定
            submitAddressFun(){
                if(this.regionForm.CityId.areaname) {
                    this.region = this.regionForm.ProvinceId.areaname + this.regionForm.CityId.areaname
                }else{
                    this.region = this.regionForm.ProvinceId.areaname 
                }
                this.areaShow = false
            },
            //获取地址
            async getAreaDataByParentFun(id,hier){
                let data = {
                    aid: id,
                    areaType: hier
                }
                let res = await optionsArea(data)
                    switch(hier){
                        case 1:
                            this.ProvinceIdList = res.Data
                            break;
                        default:
                            this.CityIdList = res.Data
                            break;
                    }
            },
            // 跳转到客户信息
            linkjobInfoFun(id) {
                this.$router.push('./freeJobInfo?JobId='+ id)
                // let routerUrl = this.$router.resolve({
                //     path: "/freeJobInfo",
                //     query: {JobId: id}
                // })
                // window.open(routerUrl.href,'_blank')
            },
        }
    };
</script>
<style lang="scss">
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        // align-items:flex-start;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>